import React, { useState, memo } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Do guests need an app?',
    answer: 'No, just tap with their phone. It opens directly in their web browser.'
  }, {
    question: 'Can I keep the photos?',
    answer: 'Yes, forever. You get a lifetime digital album of all the memories.'
  }, {
    question: 'Does it work with all phones?',
    answer: 'Yes, most modern smartphones (iPhone and Android) have NFC built-in and enabled by default.'
  }];
  return <section className="py-24 px-6 bg-dark-lighter" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <FadeIn className="text-center mb-16" data-id="element-43">
          <h2 className="font-heading text-3xl md:text-4xl text-cream" data-id="element-44">
            Frequently Asked <span className="text-gold italic" data-id="element-45">Questions</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-47">
              <div className={`border border-gold/20 rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-dark' : 'bg-dark/50 hover:bg-dark/80'}`} data-id="element-48">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left" data-id="element-49">
                  <span className="text-lg text-cream font-medium" data-id="element-50">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-51" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-52">
                  <p className="text-cream-dark/70" data-id="element-53">{faq.answer}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}